import { setFundedAtAsync } from '../../../API/order/escrow/EscrowAPI';
import { createKeyedDataAsyncSlice } from '../../createKeyedDataAsyncSlice';

export const { slice: setFundedAtSlice, asyncAction: setFundedAtAction } = createKeyedDataAsyncSlice(
  'setFundedAtSlice',
  setFundedAtAsync,
  (orderId) => orderId
);
